<template>
  <div>
    <section v-if="baustellen">
      <div class="main">

        <div class="filters">
          <div>
            <input class="filter-input" type="text" placeholder="Suchen..." v-model="bauherrFilter" />
          </div>
          <div>
            <div v-if="!nextORgFilter && !auftragsdatumFilter && !auftraggeberFilter && !endeFilter && !beginnFilter">
              Sortieren nach
              <button class="button first-btn" @click="nextRg">nächste Rechnung</button>
              <button class="button first-btn" @click="exitAuftragsdatum">Aufragsdatum</button>
              <button class="button first-btn" @click="exitAuftraggeber">Auftraggeber</button>
              <button class="button first-btn" @click="exitBeginn">Beginn</button>
              <button class="button" @click="exitEnde">Ende</button>
            </div>
            <button v-else class="button filter" @click="exitFilter">Alle Baustellen</button>
          </div>
        </div>

        <div v-if="filterBauherr.length && !nextORgFilter && !auftragsdatumFilter && !auftraggeberFilter && !endeFilter && !beginnFilter" >
          <table>
            <tbody>
              <tr class="table-head">
                <th scope="row">Bauherr</th>
                <th scope="row">Bauvorhaben</th>
                <th scope="row">Adresse</th>
                <th scope="row">Auftraggeber</th>
                <th scope="row">Erstellt</th>
                <th scope="row">Details</th>
              </tr>
              <tr v-for="baustelle in filterBauherr" v-bind:key="baustelle.id">
                <td>{{ baustelle.bauherr}}</td>
                <td>{{ baustelle.bvh}}</td>
                <td>{{ baustelle.adresse}}</td>
                <td>{{ baustelle.auftraggeber}}</td>
                <td>{{ baustelle.createdOn | formatDate}}</td>
                <td class="button-col">
                  <router-link
                    class="button arrow-button"
                    :to="{ name: 'Detail', params: { id: baustelle.id }}">
                      <span class="material-icons">arrow_forward</span>
                    </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <table
            v-if="baustellen.length && !nextORgFilter && !auftragsdatumFilter && !auftraggeberFilter && !endeFilter && !beginnFilter" 
          >
            <tbody>
              <tr class="table-head">
                <th scope="row">Bauherr</th>
                <th scope="row">Bauvorhaben</th>
                <th scope="row">Adresse</th>
                <th scope="row">Auftraggeber</th>
                <th scope="row">Erstellt</th>
              </tr>
              <tr v-for="baustelle in baustellen" v-bind:key="baustelle.id">
                <td>{{ baustelle.bauherr}}</td>
                <td>{{ baustelle.bvh}}</td>
                <td>{{ baustelle.adresse}}</td>
                <td>{{ baustelle.auftraggeber}}</td>
                <td>{{ baustelle.createdOn | formatDate}}</td>
                <td>
                  <router-link
                    class="button"
                    :to="{ name: 'Detail', params: { id: baustelle.id }}"
                  >Details</router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <p
              v-if="!nextORgFilter && !auftragsdatumFilter && !auftraggeberFilter && !endeFilter && !beginnFilter"
              class="no-results"
            >Keine Einträge vorhanden.</p>
          </div>
        </div>

        <div v-if="nextORgFilter && nextORg.length">
          <FilterRg :nextORg="nextORg" :bauherrFilter="bauherrFilter" />
        </div>

        <div v-if="auftragsdatumFilter && filterAuftr.length">
          <FilterAuftragsdatum
            :filterAuftr="filterAuftr"
            :bauherrFilter="bauherrFilter"
            :filterBauherr="filterBauherr"
          />
        </div>

        <div v-if="auftraggeberFilter && filterAuftraggeber.length">
          <FilterAuftraggeber
            :filterAuftraggeber="filterAuftraggeber"
            :bauherrFilter="bauherrFilter"
            :filterBauherr="filterBauherr"
          />
        </div>
        <div v-if="endeFilter && filterEnde.length">
          <FilterEnde
            :filterEnde="filterEnde"
            :bauherrFilter="bauherrFilter"
          />
        </div>
        <div v-if="beginnFilter && filterBeginn.length">
          <FilterBeginn
            :filterBeginn="filterBeginn"
            :bauherrFilter="bauherrFilter"
          />
        </div>
      </div>
    </section>
    <div v-else>Loading...</div>
  </div>
</template>

<script>
const fb = require("../fbConfig.js");
import moment from "moment";
import { mapState } from "vuex";
import { currentUser } from "../fbConfig";
import FilterRg from "./filter-rg";
import FilterAuftragsdatum from "./filter-auftragsdatum";
import FilterAuftraggeber from "./filter-auftraggeber";
import FilterEnde from "./filter-ende";
import FilterBeginn from "./filter-beginn";

export default {
  data() {
    return {
      bauherrFilter: "",
      nextORgFilter: false,
      auftragsdatumFilter: false,
      auftraggeberFilter: false,
      endeFilter: false,
      beginnFilter: false
    };
  },
  components: {
    FilterRg,
    FilterAuftragsdatum,
    FilterAuftraggeber,
    FilterEnde,
    FilterBeginn
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "baustellen"]),
    filterBauherr: function() {
      let inp = this.bauherrFilter.toLowerCase();
      return this.baustellen.filter(obj => {
        return Object.keys(obj).some(
          key =>
            typeof obj[key] === "string" && obj[key].toLowerCase().includes(inp)
        );
      });
    },
    nextORg: function() {
      let x = [];
      let n = 0;
      this.baustellen.forEach(el =>
        el.zahlungsplan.forEach(zp => {
          if (zp.datum) {
          zp.id = el.id;
          zp.adresse = el.adresse;
          zp.bauherr = el.bauherr;
          zp.bvh = el.bvh;
          zp.auftraggeber = el.auftraggeber;
          zp.createdOn = el.createdOn;
          zp.idx = n + 1;
          x.push(zp);
          n++;
          }
        })
      );
      let f = x.filter(el => {
        if (el.verrechnet) {
          return el.verrechnet == false;
        } else {
          return el.bezahlt == false;
        }
      });
      let s = f.sort((a, b) => new Date(a.datum) - new Date(b.datum));
      return s;
    },
    filterAuftr: function() {
      let bst = this.baustellen;
      let x = bst.sort(
        (a, b) => new Date(a.auftragsdatum) - new Date(b.auftragsdatum)
      );
      return x;
    },
    filterAuftraggeber: function() {
      let bst = this.baustellen;
      let x = bst.sort((a, b) => a.auftraggeber.localeCompare(b.auftraggeber));
      return x;
    },
    filterEnde: function() {
      let bst = this.baustellen.filter(el => {
        let ende = moment(el.ende)
        if (ende.isValid()) {
          return el
        }
      })
      bst.forEach(el => {
        if(moment(el.ende).isBetween(moment().subtract(2, 'weeks'), moment()) && !el.ufa) {
          el.alert = true
        }
        else {
          el.alert = false
        }
      })
      let x = bst.sort((a, b) => a.ende.localeCompare(b.ende));
      return x;
    },
    filterBeginn: function() {
      let bst = this.baustellen.filter(el => {
        let beginn = moment(el.beginn)
        if (beginn.isValid()) {
          return el
        }
      })
      bst.forEach(el => {
        if(moment(el.beginn).isBetween(moment(), moment().add(3, 'weeks')) && !el.vorankuendigung) {
          el.alert = true
        } else {
          el.alert = false
        }
      })
      let x = bst.sort((a, b) => b.beginn.localeCompare(a.beginn));
      return x;
    }
  },
  methods: {
    nextRg() {
      this.nextORgFilter = true;
    },
    exitFilter() {
      this.nextORgFilter = false;
      this.auftragsdatumFilter = false;
      this.auftraggeberFilter = false;
      this.endeFilter = false;
      this.beginnFilter = false;
    },
    exitAuftragsdatum() {
      this.auftragsdatumFilter = true;
    },
    exitAuftraggeber() {
      this.auftraggeberFilter = true;
    },
    exitEnde() {
      this.endeFilter = true;
    },
    exitBeginn() {
      this.beginnFilter = true;
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD.MM.YYYY");
    },
    formatStrDate(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  }
};
</script>

<style scoped>
.main {
  margin-top: 100px;
  background: #eeeeee;
  padding: 20px;
  border-radius: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 12px;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

td,
th {
  border-right: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

td:last-of-type,
th:last-of-type {
  border-right: none;
}

tr {
  height: 40px;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.button-col {
  text-align: center;
}

tfoot td {
  border: none;
  background: white;
  padding-left: 0;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.first-btn {
  margin-right: 10px;
}

.filter-input {
  box-sizing: border-box;
  border: 1px solid #999;
  outline: none;
  padding: 5px;
  background: #eeeeee;
  border-radius: 20px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  width: 200px;
  padding-left: 10px;
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
  padding-bottom: 2px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100%;
  font-size: 15px;
}
</style>